import { render, staticRenderFns } from "./SidebarBappebti.vue?vue&type=template&id=df1195c0&scoped=true&"
import script from "./SidebarBappebti.vue?vue&type=script&lang=js&"
export * from "./SidebarBappebti.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBappebti.vue?vue&type=style&index=0&id=df1195c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1195c0",
  null
  
)

export default component.exports